import React, { useState, useRef, useEffect } from 'react';
import './TestPosts.css';
import {ReactComponent as CalenderIcon} from "../../../assets/calender.svg";
import {ReactComponent as UserIcon} from "../../../assets/user.svg";
import {ReactComponent as CheckIcon} from "../../../assets/check.svg";
import {ReactComponent as StarIcon} from "../../../assets/star.svg";
import {ReactComponent as StatIcon} from "../../../assets/analysis.svg";
import {ReactComponent as DesignIcon} from "../../../assets/layout.svg";
import {ReactComponent as MlIcon} from "../../../assets/layers.svg";
import {ReactComponent as IosIcon} from "../../../assets/cell-phone.svg";
import {ReactComponent as ClockIcon} from "../../../assets/clock.svg";
import {ReactComponent as ReactIcon} from "../../../assets/physics.svg";
import {ReactComponent as BackIcon} from "../../../assets/backend.svg";
import {ReactComponent as CloudIcon} from "../../../assets/cloud.svg";
import {ReactComponent as ShieldIcon} from "../../../assets/trusted.svg";

const summaryStats = [
  { value: '9', label: 'Active Tests', change: '+2 new this week', up: true, icon: CalenderIcon ,color:'#4a8fd9'},
  { value: '1,423', label: 'Completed', change: '+241 this week', up: true, icon: UserIcon, color:'#7c6ef6' },
  { value: '71.6%', label: 'Completion Rate', change: '-2.3% vs last mo.', up: false, icon: CheckIcon, color:'#30b9c8' },
  { value: '74.2', label: 'Average Score', change: '+3.1 pts vs baseline', up: true, icon: StarIcon, color:'#3ecf7b' },
];

const tests = [
  { icon: ReactIcon, title: 'Senior Frontend Developer', sub: 'React · Distributed Systems', domain: 'Frontend', tags: ['React', 'TypeScript', 'CSS', 'Perf. Opt.'], difficulty: 'HARD', status: 'Open', time: 108, score: 74.2, passed: 73, attempted: 249, completion: 78, color: '#6c63ff' },
  { icon: BackIcon, title: 'Backend Systems Engineer', sub: 'Node.js · Distributed Systems', domain: 'Backend', tags: ['Node.js', 'PostgreSQL', 'Docker', 'System Design'], difficulty: 'EXPERT', status: 'Open', time: 90, score: 69.8, passed: 64, attempted: 183, completion: 64, color: '#4f9eff' },
  { icon: StatIcon, title: 'Data Analysis Challenge', sub: 'Python · SQL · Visualization', domain: 'Data', tags: ['Python', 'SQL', 'Pandas', 'Matplotlib'], difficulty: 'MEDIUM', status: 'Open', time: 90, score: 78.4, passed: 82, attempted: 127, completion: 52, color: '#22c55e' },
  { icon: CloudIcon, title: 'Cloud Architecture Design', sub: 'AWS · Infrastructure · Reliability', domain: 'Cloud', tags: ['AWS', 'Kubernetes', 'Terraform', 'SRE'], difficulty: 'HARD', status: 'Draft', time: 150, score: 71.1, passed: 58, attempted: 94, completion: 58, color: '#f59e0b' },
  { icon: DesignIcon, title: 'Product Design Sprint', sub: 'UX Research · Figma · Prototyping', domain: 'Design', tags: ['Figma', 'UX Research', 'Prototyping', 'Design Systems'], difficulty: 'MEDIUM', status: 'Open', time: 248, score: 80.6, passed: 86, attempted: 211, completion: 85, color: '#a855f7' },
  { icon: ShieldIcon, title: 'AppSec & Penetration Testing', sub: 'Web Security · OWASP · Exploits', domain: 'Security', tags: ['OWASP', 'Pentesting', 'Burp Suite', 'CTF'], difficulty: 'EXPERT', status: 'Open', time: 188, score: 63.4, passed: 52, attempted: 67, completion: 52, color: '#ef4444' },
  { icon: MlIcon, title: 'ML Engineering Challenge', sub: 'Training Pipelines · Model Eval.', domain: 'Data', tags: ['PyTorch', 'TensorFlow', 'MLOps', 'Feature Eng.'], difficulty: 'HARD', status: 'Open', time: 120, score: 66.3, passed: 61, attempted: 76, completion: 51, color: '#f97316' },
  { icon: IosIcon, title: 'iOS & Swift Engineering', sub: 'SwiftUI · Architecture · APIs', domain: 'Mobile', tags: ['Swift', 'SwiftUI', 'UIKit', 'CoreData'], difficulty: 'MEDIUM', status: 'Closed', time: 90, score: 72.8, passed: 73, attempted: 89, completion: 73, color: '#06b6d4' },
  { icon: ClockIcon, title: 'DevOps & CI/CD Pipelines', sub: 'Docker · GitHub Actions · Observability', domain: 'Cloud', tags: ['Docker', 'CI/CD', 'Prometheus', 'Helm'], difficulty: 'EASY', status: 'Draft', time: 60, score: 77.5, passed: 85, attempted: 142, completion: 68, color: '#84cc16' },
];

const tagColors = {
  React: { bg: '#4A90D917', color: '#7EB8ED' },
  TypeScript: { bg: '#7B6EF617', color: '#A49DF5' },
  CSS: { bg: '#30B8C814', color: '#6DD4E0' },
  'Node.js': { bg: '#7B6EF617', color: '#A49DF5' },
  PostgreSQL: { bg: '#4A90D917', color: '#7EB8ED' },
  Docker: { bg: '#30B8C814', color: '#6DD4E0' },
  Python: { bg: '#30B8C814', color: '#6DD4E0' },
  SQL: { bg: '#4A90D917', color: '#7EB8ED' },
  Pandas: { bg: '#3ECF7A12', color: '#6DE09E' },
  'Perf. Opt.': { bg: '#30B8C814', color: '#6DD4E0' },
  'System Design': {bg: '#E8A83A14', color: '#E8C475'},
  Matplotlib: {bg: '#7B6EF617', color:'#A49DF5'},
  AWS: { bg: '#4A90D917', color: '#7EB8ED' },
  Kubernetes: { bg: '#30B8C814', color: '#6DD4E0' },
  Terraform: { bg: '#7B6EF617', color: '#A49DF5' },
  SRE: {bg: '#E8A83A14', color: '#E8C475'},
  Figma: {bg :'#F66EC812', color: '#F09ED8'},
  'UX Research': { bg: '#7B6EF617', color: '#A49DF5' },
  Prototyping: { bg: '#30B8C814', color: '#6DD4E0' },
  'Design Systems': { bg: '#4A90D917', color: '#7EB8ED' },
  OWASP: {bg: '#E0585812', color:'#E89494'},
  Pentesting: {bg: '#E8A83A14', color: '#E8C475'},
  'Burp Suite': {bg: '#7B6EF617', color:'#A49DF5'},
  CTF: { bg: '#30B8C814', color: '#6DD4E0' },
  PyTorch: { bg: '#30B8C814', color: '#6DD4E0' },
  TensorFlow: { bg: '#30B8C814', color: '#6DD4E0' },
  MLOps: { bg: '#4A90D917', color: '#7EB8ED' },
  'Feature Eng.': {bg: '#E8A83A14', color: '#E8C475'},
  Swift: {bg: '#E8A83A14', color: '#E8C475'},
  SwiftUI: {bg: '#E8A83A14', color: '#E8C475'},
  UIKit: { bg: '#4A90D917', color: '#7EB8ED' },
  CoreData: { bg: '#7B6EF617', color: '#A49DF5' },
  'CI/CD': { bg: '#4A90D917', color: '#7EB8ED' },
  Prometheus: { bg: '#3ECF7A12', color: '#6DE09E' },
  Helm: { bg: '#7B6EF617', color: '#A49DF5' },
};

const diffColor = { HARD: 'red', EXPERT: 'purple', MEDIUM: 'yellow', EASY: 'green' };
const statusColor = { Open: 'green', Draft: 'yellow', Closed: 'red' };

/* ── Reusable dropdown filter ── */
function FilterDropdown({ label, options, value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const isFiltered = value !== options[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="fd-wrap" ref={ref}>
      <button
        className={`filter-btn${isFiltered ? ' active' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        {isFiltered ? value : label}
        <span className={`fd-chevron${open ? ' up' : ''}`}>▾</span>
      </button>
      {open && (
        <div className="fd-menu">
          {options.map(opt => (
            <button
              key={opt}
              className={`fd-item${value === opt ? ' selected' : ''}`}
              onClick={() => { onChange(opt); setOpen(false); }}
            >
              {opt}
              {value === opt && <span className="fd-check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function TestPosts() {
  const [statusFilter, setStatusFilter]     = useState('All Status');
  const [domainFilter, setDomainFilter]     = useState('All Domains');
  const [diffFilter,   setDiffFilter]       = useState('All Difficulty');
  const [sortBy,       setSortBy]           = useState('Default');
  const [search,       setSearch]           = useState('');

  const statusOptions    = ['All Status',    'Open', 'Draft', 'Closed'];
  const domainOptions    = ['All Domains',   'Frontend', 'Backend', 'Data', 'Cloud', 'Design', 'Security', 'Mobile'];
  const diffOptions      = ['All Difficulty','EASY', 'MEDIUM', 'HARD', 'EXPERT'];
  const sortOptions      = ['Default', 'Most Attempted', 'Highest Score', 'Fastest'];

  const anyActive = statusFilter !== 'All Status' || domainFilter !== 'All Domains' || diffFilter !== 'All Difficulty' || sortBy !== 'Default' || search !== '';

  const clearAll = () => {
    setStatusFilter('All Status');
    setDomainFilter('All Domains');
    setDiffFilter('All Difficulty');
    setSortBy('Default');
    setSearch('');
  };

  /* ── Filter + Sort logic ── */
  let filtered = tests.filter(t => {
    if (statusFilter !== 'All Status'    && t.status     !== statusFilter) return false;
    if (domainFilter !== 'All Domains'   && t.domain     !== domainFilter) return false;
    if (diffFilter   !== 'All Difficulty'&& t.difficulty !== diffFilter)   return false;
    if (search && !t.title.toLowerCase().includes(search.toLowerCase()) &&
        !t.tags.some(tag => tag.toLowerCase().includes(search.toLowerCase()))) return false;
    return true;
  });

  if (sortBy === 'Most Attempted') filtered = [...filtered].sort((a, b) => b.attempted - a.attempted);
  else if (sortBy === 'Highest Score') filtered = [...filtered].sort((a, b) => b.score - a.score);
  else if (sortBy === 'Fastest')       filtered = [...filtered].sort((a, b) => a.time - b.time);

  return (
    <div className="page testposts">
      <div className="page-header">
        <div>
          <h1 className="page-title">Test Posts</h1>
          <p className="page-sub">Manage and publish skill-based technical assessments for open roles</p>
        </div>
        <button className="btn-primary create-btn">+ Create Test</button>
      </div>

      <div className="stat-grid four">
        {summaryStats.map((s, i) => (
          <div key={i} className="stat-card1">
            <div className="stat-icon"
            style={{
              background: s.color +'22',
              color: s.color,
              boxShadow: `0 10px 30px ${s.color}22`
            }}><s.icon /></div>
            <div className='stat-card2'>
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
              <div className={`stat-change ${s.up ? 'up' : 'down'}`}>{s.change}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Filter Bar ── */}
      <div className="filter-bar">
        <div className="filter-search-wrap">
          <span className="search-icon">⌕</span>
          <input
            className="filter-search"
            type="text"
            placeholder="Search tests or skills…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <button className="search-clear" onClick={() => setSearch('')}>✕</button>
          )}
        </div>

        <FilterDropdown label="All Status"     options={statusOptions} value={statusFilter} onChange={setStatusFilter} />
        <FilterDropdown label="All Domains"    options={domainOptions} value={domainFilter} onChange={setDomainFilter} />
        <FilterDropdown label="All Difficulty" options={diffOptions}   value={diffFilter}   onChange={setDiffFilter} />
        <FilterDropdown label="Sort by"        options={sortOptions}   value={sortBy}       onChange={setSortBy} />

        {anyActive && (
          <button className="filter-clear-btn" onClick={clearAll}>
            ✕ Clear filters
          </button>
        )}

        <span className="filter-count">{filtered.length} / {tests.length} tests</span>
      </div>

      {/* ── Test Grid ── */}
      {filtered.length === 0 ? (
        <div className="no-results">
          <span className="no-results-icon">🔍</span>
          <p>No tests match your filters.</p>
          <button className="btn-outline" onClick={clearAll}>Clear filters</button>
        </div>
      ) : (
        <div className="test-grid">
          {filtered.map((t, i) => (
            <div key={i} className="test-card">
              <div className="test-card-head">
                <span className="test-icon" style={{ background: t.color + '22', color: t.color }}><t.icon /></span>
                <div className="test-badges">
                  <span className={`diff-badge ${diffColor[t.difficulty]}`}>{t.difficulty}</span>
                  <span className={`status-badge ${statusColor[t.status]}`}>● {t.status}</span>
                </div>
              </div>
              <div className="test-title">{t.title}</div>
              <div className="test-sub">{t.sub}</div>
              <div className="skill-tags">
                {t.tags.map(tag => (
                  <span
                    key={tag}
                    className="skill-tag"
                    style={{
                      background: tagColors[tag]?.bg || '#1e2535',
                      color: tagColors[tag]?.color || '#94a3b8'
                    }}
                  >
                   {tag}
                  </span>
                  ))}
              </div>
              <div className="test-stats">
                <div className="test-stat"><span className='haka'>{t.time} <span>min</span></span></div>
                <div className="test-stat"><span className='haka'>{t.score} <span>avg score</span></span></div>
                <div className="test-stat"><span className='haka'>{t.attempted} <span>attempted</span></span></div>
                <div className="test-stat"><span className='haka'>{t.passed}% <span>passed</span></span></div>
              </div>
              <div className="progress-row">
                <span>Completion rate</span>
                <span>{t.completion}%</span>
              </div>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${t.completion}%`, background: t.color }} />
              </div>
              <div className="test-actions">
                <button className="btn-outline">Preview</button>
                <button className="btn-primary">→ Manage</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}